import {apiClient} from '@/services/base/BaseService';

export async function analyticsTrackingOrdersStatus(organizationId: number, shopId: number) {
    const url = `organizations/${organizationId}/shops/${shopId}/analytics/tracking-orders-status`;
    const response = await apiClient.get(url);
    return response.data.data;
}

export async function analyticsOrdersStatus(organizationId: number, shopId: number) {
    const url = `organizations/${organizationId}/shops/${shopId}/analytics/orders`;
    const response = await apiClient.get(url);
    return response.data.data;
}
